import { Link, useParams } from 'react-router-dom';

import { useCalendars } from '@/hooks/useCalendars';
import { Button } from '@/components/ui/Button';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/Card';
import { Spinner } from '@/components/ui/Spinner';

// v1 is one calendar per elder (all buttons read the same merged schedule —
// see the account config model). The summary code still merges across a *list*
// of calendars, which is the seam a future org-shared calendar would plug
// into, but the caregiver UI surfaces exactly the one calendar — no add/delete.
export function CalendarsListPage() {
  const { aid } = useParams<{ aid: string }>();
  const { calendars, loading } = useCalendars(aid ?? null);

  return (
    <div className="mx-auto max-w-3xl space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-ink">Calendar</h1>
        <p className="mt-1 text-sm text-ink-muted">
          Events on this calendar feed the daily summary and reminders the button speaks.
        </p>
      </div>

      {loading ? (
        <div className="flex justify-center py-16">
          <Spinner />
        </div>
      ) : (
        <div className="grid gap-3">
          {calendars.map((cal) => (
            <Card key={cal.id}>
              <CardHeader>
                <div className="flex items-center justify-between">
                  <div>
                    <CardTitle>{cal.name}</CardTitle>
                    <CardDescription>Reminders calendar</CardDescription>
                  </div>
                  <Link to={`/accounts/${aid}/calendars/${cal.id}/events`}>
                    <Button variant="secondary" size="sm">
                      Open events →
                    </Button>
                  </Link>
                </div>
              </CardHeader>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
